import { Injectable } from "@angular/core";
import { DashboardService } from "../dashboard.service";
import { BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { AlertService } from "../../alert.service";
import { StorageService } from "../../storage.service";
import { ReportTypes } from "../../../reports/models/reports";
import { RetentionSummaryV2Response } from "../../../_models/dashboard";

@Injectable({
  providedIn: "root",
})
export class OrdersRetentionSummaryService extends DashboardService {
  route = "order_dashboard/retention_summary";
  protected reportType = ReportTypes.ORDER_RETENTION;
  protected data: BehaviorSubject<RetentionSummaryV2Response> = new BehaviorSubject<RetentionSummaryV2Response>(undefined);

  constructor(
    protected http: HttpClient,
    protected alertService: AlertService,
    protected storageService: StorageService
  ) {
    super(http, alertService, storageService);
  }

}
